<template>
  <div class="max-w-md mx-auto">
    <h1 class="text-2xl font-bold text-center text-gray-900 mb-6">登录账号</h1>
    
    <div class="bg-white p-6 rounded-lg shadow-md">
      <form @submit.prevent="login">
        <div v-if="error" class="mb-4 p-3 bg-red-100 text-red-700 rounded text-sm">
          {{ error }}
        </div>
        
        <div class="mb-4">
          <label for="email" class="block text-sm font-medium text-gray-700 mb-1">邮箱</label>
          <input 
            v-model="form.email" 
            type="email" 
            id="email" 
            required 
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            placeholder="example@example.com"
          />
        </div>
        
        <div class="mb-6">
          <label for="password" class="block text-sm font-medium text-gray-700 mb-1">密码</label>
          <input 
            v-model="form.password" 
            type="password" 
            id="password" 
            required 
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            placeholder="输入密码"
          />
        </div>
        
        <button 
          type="submit" 
          :disabled="loading"
          class="w-full py-2 px-4 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:bg-blue-300"
        >
          <span v-if="loading">正在登录...</span>
          <span v-else>登录</span>
        </button>
      </form>
      
      <p class="mt-4 text-center text-sm text-gray-600">
        还没有账号？
        <router-link to="/register" class="text-blue-600 hover:underline">
          立即注册
        </router-link>
      </p>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive } from 'vue';
import { useAuthStore } from '../stores/auth';
import { useRouter, useRoute } from 'vue-router';

const authStore = useAuthStore();
const router = useRouter();
const route = useRoute();

const error = ref('');
const loading = ref(false);
const form = reactive({
  email: '',
  password: ''
});

const login = async () => {
  error.value = '';
  loading.value = true;
  
  try {
    await authStore.login(form);
    
    // 如果有重定向URL，则导航到该URL
    const redirectPath = route.query.redirect || '/';
    router.push(redirectPath);
  } catch (err) {
    error.value = err.response?.data?.message || '登录失败，请检查您的邮箱和密码';
  } finally {
    loading.value = false;
  }
};
</script>